// import createHistory from "history/createBrowserHistory";
import { createBrowserHistory as createHistory } from "history";

export default createHistory();
